import type { ColumnFiltersState } from '@tanstack/react-table'
import type {
  IPortfolioInvestmentsMinMaxRange,
  IPortfolioInvestmentsRequest,
} from '~/@api/generated-api-types-account/Api'
import type { ProjectCollateralSubcategory } from '~/@pages_investing/projects/_project_types/projectCollateralSubCategory'
import type { ProjectLoanPurpose } from '~/@pages_investing/projects/_project_types/projectLoanPurpose'

type FilterValueById = {
  latestPaymentDate: number[]
  createdAt: number[]

  'project.loanPurpose': ProjectLoanPurpose[]
  'project.collateralInfo.collateralSubcategory': ProjectCollateralSubcategory[]

  // MultiSelect emituje pole {min?, max?} rozsahov (BE filter berie polia)
  value: IPortfolioInvestmentsMinMaxRange[]
  total: IPortfolioInvestmentsMinMaxRange[]
  totalYieldPerAnnum: IPortfolioInvestmentsMinMaxRange[]
}

type Filter = NonNullable<IPortfolioInvestmentsRequest>['filter']

function mapTableFiltersToRemoteFilter(
  columnFilters: ColumnFiltersState
): Filter {
  if (!columnFilters.length) {
    return undefined
  }

  const columnFilterById = _mapValues(
    _groupBy(columnFilters, 'id'),
    ([columnFilter]) => columnFilter?.value ?? []
  ) as FilterValueById

  const { value, total, totalYieldPerAnnum } = columnFilterById

  return {
    value,
    totalYieldPerAnnum,
    total,
    investmentYears: columnFilterById.createdAt,
    latestPaymentYears: columnFilterById.latestPaymentDate,
    project: {
      collateralSubcategory:
        columnFilterById['project.collateralInfo.collateralSubcategory'],
      loanPurpose: columnFilterById['project.loanPurpose'],
    },
  }
}

export { mapTableFiltersToRemoteFilter }

function _mapValues<T, R>(
  obj: Record<string, T>,
  fn: (value: T) => R
): Record<string, R> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, fn(value)])
  )
}

function _groupBy<T>(array: T[], key: keyof T): Record<string, T[]> {
  return array.reduce(
    (acc, item) => {
      const groupKey = String(item[key])
      if (!acc[groupKey]) {
        acc[groupKey] = []
      }
      acc[groupKey].push(item)
      return acc
    },
    {} as Record<string, T[]>
  )
}
